import React, { Component } from "react";
import { FormGroup, FormControl, ControlLabel, OverlayTrigger, Tooltip } from "react-bootstrap";
import LoaderButton            from "../../components/LoaderButton";
import config                  from "../../config";
import Sortable                from 'react-sortablejs';
import CreateMonthViewDay      from "./CreateMonthViewDay";
import uniqueId                from 'lodash/uniqueId';
import { PromiseTimeout }               from "../../utils/PromiseTimeout";

import { deleteExerciseObjectProps,
         deleteBlockObjectFromMonthView,
         duplicateBlockObjectFromMonthView,
         checkIfSingleBlockObjectExistsInDay,
         addNewBlock
       } from "../../utils/Object";

import { invokeDeleteProgramDay,
         invokeGetProgramMonthView,
         invokeDuplicateProgramDay,
         invokeDuplicateProgramDay_test_new,
         invokeDuplicateBlockFromMonthView
       } from "../../utils/AwsInvoke";

import { sortBlockObjectFromMonthView,
         sortWeekObjectFromMonthView
     } from "../../utils/ObjectSort";

export default class CreateMonthViewWeek extends Component {
    constructor(props) {
        super(props);

        this.state = {
            program_block: {}
        }
    }

    componentDidMount() {
        // set initial day but don't reset after every save or instantiation
        this.setState({
            program_block: null, //this.props.program_block,
            program_id:    this.props.program_id,
            week_box_height: this.props.cssWeekContainerHeight
        }, function() {
            this.getProgramData();
        });
    }

    //componentDidUpdate() not valid function
    //shouldComponentUpdate() not valid
    componentWillReceiveProps(nextProps) {
        //console.log(">>>>>>> Create Week componentWillReceiveProps() !!! <<<<<<<<<<<");

        var programObj            = nextProps.monthViewProgramBlock;
        var week_box_height       = nextProps.cssWeekContainerHeight;
        var curr_week_cont_height = this.state.week_box_height;

        if(curr_week_cont_height != week_box_height)
            this.setState({
                week_box_height: week_box_height
            })
        else if(programObj != null) {
            //console.log("NEW PROGRAM OBJ HIT !!!");
            this.setState({
                program_block: programObj
            })
        }

        //this.debugProgramBlock()

        //// Reset Monthview Data
        //console.log("nextProps.loadMonthViewData:" + nextProps.loadMonthViewData);
        if(nextProps.loadMonthViewData) {
            this.getProgramData();
        }
    }

    startTimerTest() {
        var duration = 5; //60 * 5; // 5 minutes
        var timer = duration, minutes, seconds;
        var setInt  = setInterval(function () {
            minutes = parseInt(timer / 60, 10)
            seconds = parseInt(timer % 60, 10);

            minutes = minutes < 10 ? "0" + minutes : minutes;
            seconds = seconds < 10 ? "0" + seconds : seconds;

            var dis = minutes + ":" + seconds;
            console.log("Timer: " + dis);
            if (--timer < 0) {
                timer = duration;
                clearInterval(setInt);
            }

        }, 1000);
    }

    getProgramData = async event => {
        try {
            var program_id    = this.state.program_id;
            // Test time it takes to load a program:
            // this.startTimerTest();
            console.log("GET MONTH PROGRAM DATA!!!");
            const results = await invokeGetProgramMonthView(program_id); // 1: day 1

            this.renderProgramData(results);
        } catch (e) {
            alert(e);
        }
    }

    debugProgramBlock (){
        var program_block = this.state.program_block;

        if(program_block != null)

        for(var key in program_block) {
            var value       = program_block[key];
            var week_id     = value.week_id;
            var week_order  = value.week_order;
            var day_id_tmp  = value.day_id;
            var day_order   = value.day_order;
            var block_name  = value.block_name;
            var block_order = value.block_order;
            var exercise    = value.exercise;
            var block_id    = value.block_id;
            var exer_lgth   = value.exercise_lgth;

            if(block_name != null) {
                for(var key_e in exercise) {
                    var exer            = exercise[key_e];
                    var exer_name       = exer.name;
                    var exer_id         = exer.id;
                    var set_id          = exer.set_id;
                    var exer_order      = exer.order;
                    var exer_notes      = exer.notes;
                    console.log("");
                }
            }

        }
    }

    renderProgramData (results) {
        var program_block = results.program_block;

        this.props.setProgramName(results.program_name, results.weeks_id_order);

        this.setState({
            program_name:  results.program_name,
            program_block: results.program_block,
            completedDayIds: results.completed_day_ids
        });

        // Update Month View Program Block
        // Must update the parent component in case the user wants to change the title; there's a program object in memory //
        this.props.updateMonthViewProgramBlock(program_block, this.falseSaveProgram);
    }

    falseSaveProgram (arg) {
        //console.log("Don't save program");
    }

    saveProgram = (arg) => {
        this.props.saveProgram();
    }

    updateAndSaveProgram = (tmpObj) => {
            this.props.updateMonthViewProgramBlock(tmpObj, this.saveProgram);
    }

    handleDeleteExercise (exercise_id, week_id, day_id, block_id) { //block_index,

            var programObj  = this.state.program_block;
            var tmpObj = deleteExerciseObjectProps(programObj, block_id, exercise_id);//, week_id, day_id); //block_index, exercise_index);

            this.setState({
                //program_block: tmpObj
            });

            this.props.updateMonthViewProgramBlock(tmpObj, this.saveProgram);

    }

    sortWeek(order, week_id_to, week_id_from, week_id, new_index) {
            console.log("sortWeek !!!");
            var programObj = this.state.program_block;
            //console.log("programObj: " + programObj);
            //var tmpObj = sortWeekObjectFromMonthView(programObj, order, week_id_to, week_id_from, week_id, new_index);//day_id_to, day_id_from, block_id, new_index);
            // temp remove: this.updateAndSaveProgram(tmpObj);
    }

    sortBlock(blocks_order, block_id, day_id, day_id_to, block_to_index) {
            var programObj = this.state.program_block;

            var tmpObj = sortBlockObjectFromMonthView(programObj, blocks_order, block_id, day_id, day_id_to, block_to_index);

            this.setState({
                program_block: tmpObj
            });

            this.updateAndSaveProgram(tmpObj);
    }

    duplicateBlock = async (index, week_id, day_id, block_id, total_blocks, block_name) => {
            this.props.showLoadingFooter("inherit");
            var programObj   = this.state.program_block;
            console.log("+++++++++++++++ BEGIN DUPLICATE BLOCK ++++++++++++++++");
            var tmpObj           = duplicateBlockObjectFromMonthView(week_id, day_id, block_id, block_name, total_blocks, programObj); // reorder probam obj
            var tmpObj2          = tmpObj.tmpObj
            var new_block_id     = tmpObj.new_block_id;
            var new_block_order  = tmpObj.block_order;
            var new_set_ids_arr  = tmpObj.set_id_order_arr; // add set ids based on the exercise order
            var program_id       = this.state.program_id;

            ////  This duplicates the block's values, not just the block's exercises and orders
            const results = await invokeDuplicateBlockFromMonthView(program_id, day_id, block_id, block_name, new_block_id, new_block_order, new_set_ids_arr);

            if(results.status) {
                this.setState({
                    program_block: tmpObj2
                }, function () {
                    this.updateAndSaveProgram(tmpObj2);
                })
            } else {
                var body_text  = "Sorry, there was an error. Please refresh your browser and try again.";
                this.props.setModalAlertProps("Warning", body_text, true);
                this.props.showLoadingFooter("none");
            }
    }

    //deleteBlock = (index, day_num, week_num, day_id, week_id, block_id) => {
    deleteBlock = (index, day_id, block_id) => {
        //if(index != 1) {
            var programObj = this.state.program_block;

            // Emsure at least one block exists in day //
            var total_blocks   = checkIfSingleBlockObjectExistsInDay(programObj, day_id, block_id);

            if(total_blocks > 1) {
                var tmpObj = deleteBlockObjectFromMonthView(programObj, block_id);

                this.setState({
                    program_block: tmpObj
                }, function () {
                    this.updateAndSaveProgram(tmpObj);
                })
            } else {
                var body_text  = "Sorry, you can't delete the last block in a day.";
                this.props.setModalAlertProps("Warning", body_text, true);
            }
    }

    duplicateProgramWeek = (curr_week_id) => {
        this.props.duplicateProgramWeek(curr_week_id);
    }

    deleteProgramWeek = (curr_week_id) => {
        this.props.deleteProgramWeek(curr_week_id);
    }

    addNewDayFromMonthView = async (week_id, total_days) => {

        var last_day = total_days + 1;

        this.props.createProgramDay(week_id, last_day);
    }


    duplicateDay = async(week_id, day_id, total_days_in_week) => {
            console.log("invokeDuplicateProgramDay()");

            this.props.showLoadingFooter("inherit");

            const results = await invokeDuplicateProgramDay_test_new(day_id, week_id, total_days_in_week);
            // original: const results = await invokeDuplicateProgramDay(day_id, week_id, total_days_in_week);

            if(results.status) {
                // Set Current Day to the Duplicate Day
                ///this.setState({ day_current: results.day_current}, () => {
                    this.getProgramData();
                    this.props.showLoadingFooter("none");
                //});
            } else {
                console.log("uh-oh, there's a problem.");
                this.props.showLoadingFooter("none");

            }
    }

    checkIfSingleDayExistsInWeek = (week_id) => {
            var programObj = this.state.program_block;
            var ctr = 0;
            for(var key in programObj) {
                var tmp_week_id = programObj[key].week_id;
                var day_id  = programObj[key].day_id;
                if(week_id === tmp_week_id) {
                    ctr++;
                }
            }

            return ctr;
    }

    deleteDayFromMonthView = async (week_id, day_id) => {
        var ctr = this.checkIfSingleDayExistsInWeek(week_id);

        if(ctr > 1) {
            this.props.showLoadingFooter("inherit");
            const results = await invokeDeleteProgramDay(week_id, day_id);

            if(results.status === true) {
                this.getProgramData();
                this.props.showLoadingFooter("none");
            } else
                this.props.showLoadingFooter("none");
        } else {
            var body_text = "Sorry, you can't delete the final day in a week.";
            this.props.setModalAlertProps("Warning", body_text, true);
        }
    }

    getDayFromMonthView = (day_id, day_num, curr_week, curr_week_id) => {
        this.props.getDayFromMonthView(day_num, day_id, curr_week, curr_week_id)
    }

    addNewBlockToMonthView (day_id) {
        //console.log("addNewBlockToMonthView day_id: " + day_id);
        /*var program = this.state.program_block;
        var block_index   = Object.keys(program).length;

        // Add next Block in the object's order //
        var tmpBlockObj = addNewBlock(program);

        this.setState({
            program_block: tmpBlockObj,
        }, function() {
            // auto show modal if new block:
            // this.setState({ showModalSimple: true, exercise_index: null, block_index: block_index.toString(), exercise_id: 0, exercise_name: "", measure_a_id: 1, measure_a_value: 0, measure_b_id: 2, measure_b_value: 0, rest: 0, notes: "", modalSimpleAction: "duplicate" })
        });
        */
    }

    render() {
        var week_arr = [];
        var weeks    = {};
        var days_id_order = {};
        var program_block = this.state.program_block;
        var that = this;

        var cssWeekContainerHeight = this.props.cssWeekContainerHeight;
        var cssNewDayProps = -312;
        if(cssWeekContainerHeight === 560) cssNewDayProps = -472
        else if(cssWeekContainerHeight === 720) cssNewDayProps = -632
        //else if(cssWeekContainerHeight === 200) cssNewDayProps = -632

        var total_blocks_ctr = 0;
        var curr_week_id;
        var tmp_weeks_arr  = [];
        var tmp_days_arr  = [];
        var week = [];
        var d_ctr = 0;

        //week.push(<div key={uniqueId()} >test</div>)

        //// SELECT UNIQUE WEEK IDS ////
        for(var key in program_block) {
                //console.log("key: " + key + " - program_block: " + program_block[key]);
                var program_block2 = program_block[key];
                for(var key2 in program_block2) {

                        //console.log("key2: " + key2 + " - pb2: " + program_block2[key2]);
                        var tmp_week_id    = program_block2.week_id;
                        var tmp_week_order = program_block2.week_order;
                        var index = tmp_weeks_arr.indexOf(tmp_week_id); // filter out unique week ids
                        if(index === -1) {
                            tmp_weeks_arr.push(tmp_week_id);
                        }
                        //console.log("tmp_week_id: " + tmp_week_id);

                        var tmp_day_id    = program_block2.day_id;
                        var tmp_day_order = program_block2.day_order;
                        var index2 = tmp_days_arr.indexOf(tmp_day_id); // filter out unique day ids
                        if(index2 === -1) {
                            days_id_order[d_ctr] = {}
                            days_id_order[d_ctr].week_id = tmp_week_id;
                            days_id_order[d_ctr].day_id  = tmp_day_id;
                            days_id_order[d_ctr].day     = tmp_day_order;

                            tmp_days_arr.push(tmp_day_id);
                            d_ctr++;
                        }
                        //console.log("Day id: " + program_block2.day_id);
                }
        }

        var weeks_lgth   = tmp_weeks_arr.length;

        for(var index=0; index < weeks_lgth; index++) {
                curr_week_id = tmp_weeks_arr[index];
                //if(tmp_weeks_arr[index] != undefined) curr_week_id = tmp_weeks_arr[index];

                var day_arr      = [];
                var day_ids_arr  = [];
                var d_lgth       = tmp_days_arr.length;

                // TMP PLACEHOLDER, REMOVE FOR LOOP later
                for(var i=0; i < d_lgth; i++) {

                    var tmp_day      = days_id_order[i];
                    var last_week_id = tmp_day.week_id;
                    var curr_day     = tmp_day.day;
                    var day_id       = tmp_day.day_id; //uid comes from database

                    // temp fix below; need to convert uid to day_id
                    //if(day_id === undefined) day_id = tmp_day.day_id; //in app, day_id is used instead of uid

                    if(curr_week_id === last_week_id) {
                        day_arr.push(curr_day);
                        day_ids_arr.push(day_id);
                    }
                }

                var curr_week = parseInt(index) + 1;
                var total_week_days = day_arr.length
                week.push(  <div //key={index}
                                 className="weekMainContainer"
                                 key={uniqueId()}
                                 id={"week_"+curr_week} // new addition to attr
                                 week_id = {curr_week_id}
                                 data-id = { curr_week_id }
                                 style={{ borderBottom:"0px solid black"}}
                            >
                                    <span className="weekMainTitleText"
                                          week_id = {curr_week_id}
                                    >
                                        WEEK { curr_week } { /*curr_week_id /* */ }
                                    </span>
                                    { /*}<span className="glyphicon weekMainSingleWeekEditIcons0"
                                          onClick={that.addNewDayFromMonthView.bind(that, curr_week_id)}
                                    > ... </span> */}
                                    <OverlayTrigger
                                            key       = {uniqueId()} /*"top"*/
                                            placement = "top"
                                            overlay={
                                              <Tooltip id = "top" style={{fontSize:16}}>
                                                Duplicate Week
                                              </Tooltip>
                                            }
                                    >
                                        <span className="glyphicon glyphicon-duplicate weekMainSingleWeekEditIcons1"
                                              onClick={this.duplicateProgramWeek.bind(this, curr_week_id)}
                                        />
                                    </OverlayTrigger>
                                    <OverlayTrigger
                                            key       = {uniqueId()} /*"top"*/
                                            placement = "top"
                                            overlay={
                                              <Tooltip id = "top" style={{fontSize:16}}>
                                                Delete Week
                                              </Tooltip>
                                            }
                                    >
                                    <span className="glyphicon glyphicon-remove weekMainSingleWeekEditIcons2"
                                          onClick={this.deleteProgramWeek.bind(this, curr_week_id)}
                                    />
                                    </OverlayTrigger>

                                    <span className="week__handle weekMainSingleDayContainer"
                                         style={{height:cssWeekContainerHeight}}>

                                        <CreateMonthViewDay className         = "trackMonthViewDayBox"
                                                            setModalAlertProps = {this.props.setModalAlertProps}
                                                            showDayModalSimple = {this.props.showDayModalSimple}
                                                            openAddNewExerciseModal = {this.props.openAddNewExerciseModal}
                                                            editMonthViewExercise   = {this.props.editMonthViewExercise}
                                                            addBlock                = {this.props.addBlock}
                                                            addFreeFormBlock        = {this.props.addFreeFormBlock}
                                                            program_block     = {program_block}
                                                            completedDayIds   = {this.state.completedDayIds}
                                                            getProgramDOMTree = {this.props.getProgramDOMTree}
                                                            days              = {day_arr}
                                                            day_id            = {day_id}
                                                            day_ids           = {day_ids_arr}
                                                            week_id           = {curr_week_id}
                                                            current_week      = {curr_week}
                                                            total_week_days   = {total_week_days}
                                                            week_box_height   = {this.state.week_box_height}
                                                            duplicateBlock    = {this.duplicateBlock.bind(this)}
                                                            deleteBlock       = {this.deleteBlock.bind(this)}
                                                            sortBlock         = {this.sortBlock.bind(this)}
                                                            duplicateDay      = {that.duplicateDay.bind(that)}
                                                            deleteDay         = {that.deleteDayFromMonthView.bind(that)}
                                                            addNewDayFromMonthView = {this.addNewDayFromMonthView.bind(this)}
                                                            addNewBlockToMonthView = {this.addNewBlockToMonthView.bind(this)}
                                                            getDayFromMonthView = {this.getDayFromMonthView.bind(this)}
                                        />

                                        { /*}<span className="weekMainSingleWeekEditIcons0"
                                              style= {{ position:"absolute", top:cssWeekContainerHeight-90, right:20}}
                                              onClick={that.addNewDayFromMonthView.bind(that, curr_week_id, total_week_days)}
                                        > + Day </span>*/ }
                                    </span>
                            </div>
                )
        }

        var sortableWeeks = <span className = "trackMonthViewWeekContainer"
                                  style={{display:"inline-block", height:"100%", width:"100%", backgroundColor:"ccc"}}>
                                <Sortable
                                        className = "trackMonthViewParent"
                                        options={{
                                            group: "weeks",
                                            sort: true,
                                			animation: 150,
                                            // not useable: onStart: (evt) => { },

                                            onChoose: function (/**Event*/ evt) {
                                                console.log("on hooooseee +++++++++++++++++++++++");
                                             },
                                             // Element is unchosen
                                              onUnchoose: function (/**Event*/ evt) {
                                                console.log("unchoooose ------------------");
                                              },
                                              onChange: function (/**Event*/ evt) {
                                                console.log("chaaanngeee===========");
                                              },
                                            onMove: function (/**Event*/ evt, /**Event*/ originalEvent) {
                                                   console.log("on mooooveeee..........");
                                            },

                                            onEnd: (evt) => {
                                                console.log("sortWeek!!!");
                                                this.props.getProgramDOMTree();
                                                //this.sortWeek();
                                            }
                                        }}
                                >
                                    {week}
                                </Sortable>
                        </span>

        return sortableWeeks;
    }
}



// WEBPACK FOOTER //
// ./src/screens/program/CreateMonthViewWeek.js